export class Plant {
  Id: number;
  Type: number;
  CompanyId: number;
  Name: string;
  Location: string;
  Description: string;
  Thumbnail: string;
  Attachments: string;
  CreatedAt: string;
  UpdatedAt: string;
  Region: string;
}
